/* ---------------------------------------------------------------
   Capa custom de jiameng — comportamiento que el CSS no alcanza.

   Regla igual que la de assets/jiameng.css: aca va solo lo que no se
   puede resolver con los settings ni con una hoja de estilos.
   --------------------------------------------------------------- */

/**
 * Retira la barra sticky de agregar al carrito cuando el footer se acerca.
 *
 * Por que JS y no CSS:
 *
 * 1. La alternativa declarativa es `animation-timeline: view()`. Safari no
 *    la soporta de forma confiable y en Uruguay el trafico movil es casi
 *    todo iPhone: el fallback seria "la barra nunca se esconde", que es
 *    exactamente el bug que estamos arreglando.
 * 2. Ademas la barra ya tiene una maquina de estados propia en
 *    assets/sticky-add-to-cart.js (atributo data-stuck + una transicion
 *    con `transition-behavior: allow-discrete`). Una animacion scroll-driven
 *    competiria con esa transicion por las mismas propiedades. Un observer
 *    que solo prende y apaga un atributo deja que el CSS de la seccion siga
 *    siendo el unico que anima.
 *
 * Por que una capa propia y no un fix a Horizon:
 *
 * Horizon ya trae un observer del footer (#mainBottomObserver, en
 * assets/sticky-add-to-cart.js, con `rootMargin: '200px 0px 0px 0px'`).
 * Ese margen agranda el borde SUPERIOR del root, no el inferior, asi que
 * solo reacciona cuando el footer ya entro en pantalla — y en el preview la
 * barra se quedaba encima de los links del footer igual. Este observer es
 * independiente, agranda el borde de abajo y retira la barra ANTES de que
 * el footer la toque. No pisa el archivo de upstream, asi que `npm run
 * upstream` no genera conflicto.
 */
(() => {
  const ATTRIBUTE = 'data-jm-footer-near';

  // La barra se apoya a 20px del borde inferior y mide ~72px de alto. Con
  // 160px de margen empieza a irse mientras el footer todavia esta abajo
  // del pliegue, y nunca llega a superponerse.
  const ROOT_MARGIN = '0px 0px 160px 0px';

  /** @type {IntersectionObserver | null} */
  let observer = null;

  const setup = () => {
    observer?.disconnect();
    observer = null;

    // Solo existe en la pagina de producto y solo si el ajuste esta prendido.
    if (!document.querySelector('sticky-add-to-cart')) return;

    const footer = document.querySelector('footer');
    if (!footer) return;

    observer = new IntersectionObserver(
      (entries) => {
        const near = entries.some((entry) => entry.isIntersecting);

        for (const bar of document.querySelectorAll('sticky-add-to-cart')) {
          bar.toggleAttribute(ATTRIBUTE, near);
        }
      },
      { rootMargin: ROOT_MARGIN }
    );

    observer.observe(footer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  // El editor de themes reemplaza secciones enteras sin recargar la pagina:
  // si se re-renderiza la de producto o la del footer, el nodo observado
  // deja de existir y hay que volver a engancharse.
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
})();
